import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraInfo = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraInfo/SamsaraInfo")
);

export const SamsaraInfoPage = () => {
  return (
    <Layout>
      <SamsaraInfo />
    </Layout>
  );
};
